// import { useState } from "react";
// import { Tab, Tabs } from "react-bootstrap";
// import Filterstatsofmap from "./StaticsMapSearchForm";
// import LightningMapFunctionality from "./LightningMapFunctionality";
// import DatapanelDeathdata from "../../RoadAccident/DP_DeathData/DatapanelDeathdata"
import LightningStatsDashboard from "./LightningStatsDashboard";


const Statistics = () => {
  // const [key, setKey] = useState("mapview");

  return (
    // <div className="formcontainer1 container mt-4">
    //   <div className="container mt-4">
    //   <Tabs
    //     id="stats-tabs"
    //     activeKey={key}
    //     onSelect={(k) => setKey(k)}
    //     className="mb-3"
    //     style={{ color: "black" }}
    //   >
    //     <Tab eventKey="mapview" title="Map View" style={{ color: "black" }}>
    //       {/* <TableStats /> */}
    //       <Filterstatsofmap/>
    //       <LightningMapFunctionality/>
    //     </Tab>
    //     <Tab eventKey="statistics" title="Statistics" style={{ color: "black" }}>
          
    //         {/* <Filterstatsofmap/> */}
    //         <DatapanelDeathdata/>
          
    //     </Tab>
    //   </Tabs>
    // </div>
    // </div>
    <div>
      <LightningStatsDashboard />
    </div>
  );
};

export default Statistics;


